<h4 class="fw-bold my-3">{{ "provisioning.organization_structure" | translate }}</h4>

<div class="bg-card m-2 p-2">
    @if (selectedUnit()) {
        <div class="d-flex justify-content-end my-2" *adaaHasPermission="createPermission()">
            <button
                type="button"
                class="btn btn-sm bg-light text-primary rounded-circle shadow-sm"
                [title]="'tooltips.add' | translate"
                (click)="openEditor()"
            >
                <fa-icon [icon]="['fas', 'plus']"></fa-icon>
            </button>
        </div>
    }
    <table class="w-100">
        <thead class="table--header">
            <tr>
                <th class="blank">&nbsp;</th>
                <th class="level">{{ "entity.create.level" | translate }}</th>
                <th class="name">{{ "common.tables.name" | translate }}</th>
                <th class="actions print-ignore">{{ "common.tables.actions" | translate }}</th>
            </tr>
        </thead>
    </table>
    <adaa-organization-structure
        [level]="1"
        [childs]="arrayOfOrgUnitsStructured()"
        [currentSelectedOrgUnit]="selectedUnit()?.id"
        (selectedUnit)="setSelectedUnit($event)"
        (actionClicked)="getAction($event)"
    />
</div>

<adaa-organization-unit-editor
    #editor
    [pageMode]="pageMode()"
    [parentOrgUnit]="parentOrgUnit()"
    [entity]="entity()"
    [orgUnitOptions]="orgUnitOptions()"
    [formValidation]="formValidation()"
    (submitForm)="submit($event)"
/>
